import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from 'shell-models-lib';
import { SqlBaseSettings } from './sql-base-settings';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { IntegerDataFlowType } from '../dataflow-datatype';
import { DataFlowExpression } from '../dataflowexpression';
import { DataFlowSource } from '../dataflow-source';

@Metamodel.model({
    name: adfModelTypeMap.Warehouse.dataflowSettings,
    validator: SqlBaseSettings.validateSettings
})
export class WarehouseSettings extends SqlBaseSettings {
    @Metamodel.attribute({
    })
    public staged: boolean;

    @Metamodel.attribute({
        constraint: {
            validator: DataFlowSource.validateBatchSize
        }
    })
    public batchSize: DataFlowExpression;

    public useCopyCommandForStaging: boolean;

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Warehouse;
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.staged = !(this.owner instanceof DataFlowSource);
        this.useCopyCommandForStaging = true;
        this.store = DatasetFormatType.Warehouse;
        this.batchSize = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
    }
}